var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRefIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.55 12.206 8.713 9.049H7.493v3.157H6.485v-7.72h2.493c.583 0 1.074.099 1.473.298.406.2.709.47.908.809.2.34.3.727.3 1.163 0 .532-.156 1-.466 1.407-.303.406-.76.676-1.373.809l1.938 3.234h-1.207ZM7.494 8.24h1.485c.546 0 .956-.132 1.23-.398.272-.274.409-.635.409-1.086 0-.458-.137-.812-.41-1.063-.266-.251-.675-.377-1.23-.377H7.494V8.24Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 13,
  x: -0.707,
  y: 8.485,
  stroke: "currentColor",
  rx: 4.5,
  transform: "rotate(-45 -.707 8.485)"
})));
export default SvgRefIcon;